import { useEffect } from "react";

export default () => {
  useEffect(() => {
    if (import.meta.env.VITE_ENV !== "production") {
      return;
    }

    // AWIN Mastertag
    const script = document.createElement("script");
    script.src = "https://www.dwin1.com/101779.js";
    script.async = true;
    document.body.appendChild(script);

    // AWIN Source Handler

    const cookieLength = 30; // Cookie length in days
    const sourceParameter = ["utm_source", "gclid"]; // The parameters used by paid medias to determine the origin of the click
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const cookieDomain = ".streamily.com";
    const organicFilter = false; // "true" will consider SEO as other channels, "false" Awin will measure organic traffic after interactions with an Awin link.
    const latency = new Date(
      Date.now() + cookieLength * 24 * 60 * 60 * 1000,
    ).toUTCString();

    // Check if user is merely navigating the website's pages or if it is the first access.
    if (!document.referrer.includes(window.location.hostname)) {
      let origin;

      // Check if user accessed the website through parallel tracking links.
      if (window.location.href.indexOf("awaid") > -1) {
        origin = "aw";
      } else if (
        organicFilter === true &&
        (document.referrer.includes("google") ||
          document.referrer.includes("yahoo") ||
          document.referrer.includes("bing") ||
          document.referrer.includes("yandex") ||
          document.referrer.includes("duckduckgo"))
      ) {
        // Check if the user came from SEO links and de-dupe against it if organic filter is enabled.
        origin = "other";
      } else {
        // Check if Awin was the last paid click referring channel
        for (let i = 0; i < sourceParameter.length; i++) {
          if (queryString.includes(sourceParameter[i])) {
            const sourceValue = urlParams.get(sourceParameter[i]);
            origin =
              sourceValue === "awin" ||
              sourceValue === null ||
              sourceValue === "undefined"
                ? "aw"
                : "other";
            break;
          } else {
            // No source parameter found, store "aw" as origin as a fallback to account for tracking errors.
            origin = "aw";
          }
        }
      }

      // Store the origin
      document.cookie = `AwinChannelCookie=${origin}; expires=${latency};path=/; Domain=${cookieDomain}`;
    }

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
};
